/**
 * Map a recurring frequency to its i18n label key. Views translate the key
 * with their own `t()` — keeping the mapping here stops each view from
 * re-declaring (and drifting from) the same table. The English-only
 * `getFrequencyLabel` in recurringTransactionService is NOT for UI text.
 */
const FREQUENCY_LABEL_KEYS: Record<string, string> = {
  weekly: "budgets.frequencies.weekly",
  "bi-weekly": "budgets.frequencies.biweekly",
  monthly: "budgets.frequencies.monthly",
  quarterly: "budgets.frequencies.quarterly",
  annually: "budgets.frequencies.annually",
}

export function frequencyLabelKey(frequency: string): string | null {
  return FREQUENCY_LABEL_KEYS[frequency] ?? null
}
